import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import withTranslation from '../helpers/withTranslation';
import UspCard from '../UspCard/UspCard';
import ContactCard from '../ContactCard';
import ProgressCard from '../ProgressCard';
import ApplyUspCard from '../ApplyUspCard';
import SigninCard from '../SigninCard';
import VacancyCard from '../VacancyCard';

import ExtraUspMobile from '../ExtraUspMobile';
import { AppContext } from '../../AppContext';

const Cards = {
  progress: ProgressCard,
  usp: UspCard,
  contact: ContactCard,
  applyusp: ApplyUspCard,
  extrauspmobile: ExtraUspMobile,
  signin: SigninCard,
  vacancy: VacancyCard
};

const Sidebar = ({ t }) => {
  const { pages, pageConfig, currentPageIndex, signupFor } =
    useContext(AppContext);

  const { sidebar } = pageConfig;

  return sidebar.map((c, index) => {
    const Component = Cards[c.type];
    return (
      <Component
        t={t}
        key={index}
        currentPageIndex={currentPageIndex}
        pages={pages}
        signupFor={signupFor}
      />
    );
  });
};

Sidebar.propTypes = {
  t: PropTypes.func.isRequired
};

export default withTranslation()(Sidebar);
